import api from "./api";

export default class UserVerifyService {
    async startPhoneVerification(to: string, channel: "sms" | "whatsapp" = "sms"): Promise<{ success: boolean, error?: string, status?: number }> {
        const result = await api.post("/v1/phone-verification/start", {
            to,
            channel
        });

        return result.data;
    }

    async checkPhoneVerification(to: string, code: string): Promise<{ success: boolean, error?: string, status?: number }> {
        const result = await api.post("/v1/phone-verification/check", {
            to,
            code
        });

        return result.data;
    }
}
